export default __webpack_public_path__ + "static/media/landing_section_1_image.dc0a124d.svg";